var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"leadtimeboxplot",staticStyle:{"min-height":"400px"}}),(_vm.data)?_c('lead-time-delivery-table',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }